import React, { useState } from "react";
import {
  FiDownload,
  FiUsers,
  FiTrash2,
  FiCheckSquare,
  FiActivity,
} from "react-icons/fi";

import {
  exportLeads,
  exportDrops,
  exportTasks,
  exportActivityTimeline,
} from "./api";

const EXPORT_FUNCTIONS = {
  lead: exportLeads,
  drop: exportDrops,
  task: exportTasks,
  activity: exportActivityTimeline,
};

const EXPORT_FILENAMES = {
  lead: "aranyaka_lead_report",
  drop: "aranyaka_drop_report",
  task: "aranyaka_my_task",
  activity: "aranyaka_activity_timeline",
};

export default function Export() {
  const [loading, setLoading] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const exportOptions = [
    {
      id: "lead",
      title: "Lead",
      description: "Export all leads from the CRM",
      icon: FiUsers,
    },
    {
      id: "drop",
      title: "Drop",
      description: "Export all dropped leads",
      icon: FiTrash2,
    },
    {
      id: "task",
      title: "My Task",
      description: "Export task data",
      icon: FiCheckSquare,
    },
    {
      id: "activity",
      title: "Activity Timeline",
      description: "Export complete activity timeline",
      icon: FiActivity,
    },
  ];

  const handleExport = async (type) => {
    try {
      setLoading(type);

      const exportFunction = EXPORT_FUNCTIONS[type];

      if (!exportFunction) {
        throw new Error("Invalid export type");
      }

      if (!fromDate || !toDate) {
  alert("Please select From Date and To Date.");
  setLoading(null);
  return;
}

if (fromDate > toDate) {
  alert("From Date cannot be greater than To Date.");
  setLoading(null);
  return;
}

const response = await exportFunction({
  start_date: fromDate,
  end_date: toDate,
});

      const blob = new Blob(
        [response.data],
        { type: "text/csv;charset=utf-8;" }
      );

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;
      link.download = `${EXPORT_FILENAMES[type]}_${fromDate}_to_${toDate}.csv`;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("EXPORT ERROR:", error);

      if (error.response?.status === 403) {
        alert("You are not authorized to export this data.");
      } else if (error.response?.status === 401) {
        alert("Your session has expired. Please login again.");
      } else {
        alert(
          error.response?.data?.error ||
          "Export failed. Please try again."
        );
      }
    } finally {
      setLoading(null);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: "#f7f7f5",
      }}
    >
      {/* Header */}
      <div className="page-header">
        <div>
          <div className="page-title">
            Export
          </div>

          <div className="page-subtitle">
            Export CRM data
          </div>
        </div>
      </div>

{/* Date Range */}
<div
  style={{
    padding: "18px 24px",
    background: "#fff",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
  }}
>
  <div
    style={{
      display: "flex",
      alignItems: "flex-end",
      gap: "14px",
      maxWidth: "900px",
    }}
  >
    <div>
      <div
        style={{
          fontSize: "12px",
          fontWeight: "600",
          color: "#555",
          marginBottom: "6px",
        }}
      >
        From Date
      </div>

      <input
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        style={{
          height: "38px",
          padding: "0 10px",
          border: "1px solid #d8d8d8",
          borderRadius: "8px",
          fontSize: "13px",
          outline: "none",
        }}
      />
    </div>

    <div>
      <div
        style={{
          fontSize: "12px",
          fontWeight: "600",
          color: "#555",
          marginBottom: "6px",
        }}
      >
        To Date
      </div>

      <input
        type="date"
        value={toDate}
        min={fromDate || undefined}
        onChange={(e) => setToDate(e.target.value)}
        style={{
          height: "38px",
          padding: "0 10px",
          border: "1px solid #d8d8d8",
          borderRadius: "8px",
          fontSize: "13px",
          outline: "none",
        }}
      />
    </div>

    {(fromDate || toDate) && (
      <button
        type="button"
        onClick={() => {
          setFromDate("");
          setToDate("");
        }}
        style={{
          height: "38px",
          padding: "0 14px",
          border: "1px solid #ddd",
          background: "#fff",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "12px",
          color: "#666",
        }}
      >
        Clear
      </button>
    )}
  </div>

  <div
    style={{
      marginTop: "8px",
      fontSize: "11px",
      color: "#888",
    }}
  >
    Select From Date and To Date before exporting.
  </div>
</div>

      {/* Body */}
      <div
        className="page-body"
        style={{
          padding: "24px",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#333",
              marginBottom: "14px",
            }}
          >
            Select Data to Export
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(2, minmax(0, 1fr))",
              gap: "14px",
            }}
          >
            {exportOptions.map((item) => {
              const Icon = item.icon;
              const isLoading = loading === item.id;

              return (
                <button
                  key={item.id}
                  type="button"
                  disabled={loading !== null}
                  onClick={() => handleExport(item.id)}
                  style={{
                    border:
                      "1px solid rgba(0,0,0,0.10)",
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "20px",
                    cursor:
                      loading !== null
                        ? "not-allowed"
                        : "pointer",
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    opacity:
                      loading !== null &&
                      !isLoading
                        ? 0.6
                        : 1,
                    transition:
                      "all 0.15s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (loading !== null) return;

                    e.currentTarget.style.borderColor =
                      "#1D9E75";

                    e.currentTarget.style.boxShadow =
                      "0 4px 14px rgba(0,0,0,0.08)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor =
                      "rgba(0,0,0,0.10)";

                    e.currentTarget.style.boxShadow =
                      "none";
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "10px",
                      background: "#E8F5F0",
                      color: "#1D9E75",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Icon size={20} />
                  </div>

                  <div
                    style={{
                      flex: 1,
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#222",
                        marginBottom: "4px",
                      }}
                    >
                      {isLoading
                        ? "Exporting..."
                        : item.title}
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#888",
                      }}
                    >
                      {item.description}
                    </div>
                  </div>

                  {isLoading ? (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#1D9E75",
                        fontWeight: "600",
                      }}
                    >
                      Please wait...
                    </div>
                  ) : (
                    <FiDownload
                      size={18}
                      style={{
                        color: "#999",
                      }}
                    />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}